import React, {lazy} from 'react';
import {ROUTE_MANAGER_ASSIST} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const ManagerAssist = lazy(() =>
  import('../../../screens/ManagerAssist')
    .then(module => ({default: module.ManagerAssist})));

const ManagerAssistNavigation = [
  {
    path: ROUTE_MANAGER_ASSIST,
    loader: authLoader,
    element: (
      <ManagerAssist />
    ),
  },
];

export default ManagerAssistNavigation;
